const cookieA11Y = (el, body) => {

    let cookie = el.getAttribute('data-cookie'),
        date = new Date(),
        removeCookie = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0)
    
    if (body.hasAttribute('data-' + cookie)) {
        body.removeAttribute('data-' + cookie)
        document.cookie = cookie + '=no; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    }
    else {
        body.setAttribute('data-' + cookie, 'true')
        document.cookie = cookie + '=yes; expires=' + removeCookie + '; path=/';
    }
}

const resizeFont = (body) => {
    
    let resizeContainer = document.querySelector('.modal-content');

	if (!resizeContainer)
		return;

	let starter = 1.6;

    resizeContainer.addEventListener('click', (e) => {

        let el = e.target;

        if (el.classList.contains('down-font-size') && starter > 1.2) {
            starter = starter - .2
            body.style.fontSize = starter + 'em'
        }

        if (el.classList.contains('up-font-size') && starter < 2) {
            starter = starter + .2
            body.style.fontSize = starter + 'em'
        }

    });
}

const resetA11Y = (body) => {
    if (body.hasAttribute('data-greyscale')) {
        document.cookie = 'greyscale=no; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        body.removeAttribute('data-greyscale')
    }

    if (body.hasAttribute('data-contrast')) {
        document.cookie = 'contrast=no; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        body.removeAttribute('data-contrast')
    }

    if (body.hasAttribute('data-linkunder')) {
        document.cookie = 'linkunder=no; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        body.removeAttribute('data-linkunder')
    }
    
    console.log(document.cookie)
    body.style.fontSize = '1.6em';
}

export {cookieA11Y, resizeFont, resetA11Y}